import React from 'react';
import styles from './CalculatorLayout.module.css';

const CalculatorLayout = ({ title, highlightChar, hideTitle, children }) => {
  return (
    <div className={styles.layoutWrapper}>
      {title && !hideTitle && (
        <h1 className="marginTop100 marginBottom25 text-center">
          <span className="reciprocityGreenText">{highlightChar}</span>
          {title}
          <span className="reciprocityLightBlueText">.</span>
        </h1>
      )}
      <div className={styles.content}>
        {children}
      </div>
    </div>
  );
};

export default CalculatorLayout;